import React, { useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Page from '../../../components/PageWrapper';
import clsx from 'clsx';
import RedactInfo from '../../../components/elements/RedactInfo';
import ToolTip from '../../../components/ToolTip';
import moment from 'moment';
import useRoute from '../../../hooks/routesHook';
import {
  capitalizeSentence,
  getFormattedDate,
  getFormattedPaymentChannel,
  getPhoneNumberFromShortCodeFormat,
  numberWithCommas,
  sentenceCase,
  showToast
} from '../../../utils/miscFunctions';
import { PAYMENT_STATUS_STATES, POLICY_DOCUMENT_TYPES, POLICY_REVIEW_STATES, REDACT_INFO_TYPES } from '../../../resources/enums';
import useUserAccount from '../../../hooks/userAccountHook';
import {
  approveRNPLApplication,
  downloadPolicyDocument,
  generateRNPLPayment,
  getRNPLPayment,
  getSingleRNPLCustomer,
} from '../../../api/requests';
import BackButton from '../../../components/BackButton';
import PolicyStatus from '../../../components/elements/PolicyStatus';
import PopOnMe from '../../../components/elements/poponme';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import TextArea from '../../../components/form-control/TextArea';
import Loader from '../../../components/Loader';
import { IPolicyDocument } from '../../../resources/interfaces';
import fileDownload from 'js-file-download';
import useModal from '../../../hooks/modalHook';
import EditRNPL from './EditRNPL';
import GTable from '../../../components/elements/GTable';
import TabContent from '../../../components/tabs/TabContent';
import { INPUT_DATE_FORMAT, NEW_OWNER_YET_TO_CHANGE_AT_DVLA } from '../../../resources/constants';
import PaymentStatus from '../../../components/PaymentStatus';
import TabNavItem from '../../../components/tabs/TabNavItem';
import ActionConfirmation from '../../../components/elements/ActionConfirmation';
import { ITableAction } from '../../../components/elements/GTable/GTable';
import ActivityStepper from '../../../components/ActivityStepper';
import RNPLPreapproval from './RNLPPreapprovalModal';
import EditReviewStage from './EditReviewStage';
import PaymentAnalysis from '../../../components/PaymentAnalysis';
import VehicleInfo from '../vehicle-verification/VehicleInfo';
import { AppWindow, BadgeCheck, CalendarClock, CheckCircle, ClipboardList, CreditCard, Download, Eye, FileSearch, FileText, Info, Link2, Pencil, Percent, PhoneIcon, RotateCcw, Send, ShieldCheck, UserIcon, UserPlus, Wallet, Zap } from 'lucide-react';
import ActionsPopOnMe from '../../../components/ActionsPopOnMe';
import { LuCalendarClock } from 'react-icons/lu';
import { BsMailbox, BsShield } from 'react-icons/bs';
import { AiOutlineCheckCircle, AiOutlineClockCircle, AiOutlineCloseCircle, AiOutlineExclamationCircle, AiOutlineQuestionCircle } from 'react-icons/ai';
import { MdTrendingDown, MdTrendingUp } from 'react-icons/md';
import CustomerInfo from '../../../components/CustomerInfo';
import useRNPL from '../../../hooks/rnplHook';

interface IPolicyDetailsProps {
  previousPath: string;
}
interface PolicyDocument {
  id: string;
  name: string;
  type: string;
  uploadedAt: string;
  size: number;
  url: string;
}

const RNPLApplicantDetails = (props: IPolicyDetailsProps) => {
  const { getDashboardBase } = useRoute();
  const navigate = useNavigate();
  const { user } = useUserAccount();
  const [RNPLApplication, setRNPLApplication] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<boolean>(false);
  const [loadingPayment, setLoadingPayment] = useState(true);
  const params = useParams();
  const rnplId = params?.id;
  const queryClient = useQueryClient();
  const { ModalComponent, updateModalStates, closeModal } = useModal();
  const { handleApplyLoanToRNPL } = useRNPL();
  const [payments, setPayments] = useState<any>([]);
  const pageRef = useRef<HTMLDivElement>(null);
  const [activeTab, setActiveTab] = useState('payments');
  const documents: PolicyDocument[] = [
    {
      id: 'doc-1',
      name: 'RNPL Agreement',
      type: 'pdf',
      uploadedAt: '2024-01-01',
      size: 2500000,
      url: '#'
    },
    {
      id: 'doc-2',
      name: 'Vehicle Registration',
      type: 'pdf',
      uploadedAt: '2024-01-01',
      size: 1200000,
      url: '#'
    },
  ];

  const displayRNPLApplicant = () => {
    rnplId &&
      getSingleRNPLCustomer(rnplId)
        .then((response: any) => {
          setRNPLApplication(response?.data);
        })
        .catch((error) => {
          console.log(error);
          setError(true)
        })
        .finally(() => {
          setLoading(false);
        });
  };

  const { } = useQuery<any, Error>({
    queryKey: ['displayRNPLApplicant'],
    queryFn: displayRNPLApplicant,
    enabled: !!rnplId
  });

  const invalidateQueries = () => {
    queryClient.invalidateQueries({ queryKey: ['displayRNPLApplicant'] });
  };

  const invalidateQueriesPayments = () => {
    queryClient.invalidateQueries({ queryKey: ['allRNPLPayments'] });
  };

  const totalPaymentsAmount = () => {
    const amount = payments && payments?.map((payment: any, i: number) => {
      return payment?.paymentStatus == PAYMENT_STATUS_STATES.SUCCESS && payment?.amount;
    });

    let startVal = 0;
    let x = 0;
    while (x < amount?.length) {
      startVal = startVal + amount[x];
      x++;
    }

    return startVal;
  };

  //  const runPaymentAnalysis = () =>{
  //     runPaymentAnalysisOnCustomer(Number(financingApplication?.customer?.id))
  //     .then((response) =>{
  //       setPaymentAnalysis(response);
  //     })
  //   }

  const allRNPLPayments = () => {

    rnplId &&
      getRNPLPayment(String(rnplId))
        .then((response: any) => {
          setPayments(response?.data);
        })
        .catch((error: any) => {
          console.log(error);
        })
        .finally(() => {
          setLoadingPayment(false)
        });
  };


  const { } = useQuery<any, Error>({
    queryKey: ['allRNPLPayments'],
    queryFn: allRNPLPayments,
    enabled: !!rnplId
  });

  const orderPaymentsById = payments && payments.sort((a: any, b: any) => a.id - b.id)

  const localDate = new Date();
  const paymentDate = localDate ? moment(localDate).format(INPUT_DATE_FORMAT) : '';


  const approveRNPL = () => {
    updateModalStates({
      show: true,
      size: 'sm',
      showCloseButton: false,
      children: (
        <ActionConfirmation
          action="Approve"
          type='success'
          resourceType={''}
          resourceName={''}
          onClose={closeModal}
          onConfirm={() => {
            approveRNPLApplication(RNPLApplication?.id)
              .then((response: any) => {
                showToast.success(response?.message || 'RNPL updated successfully.');
                closeModal();
                invalidateQueries();
              })
              .catch((error: any) => {
                showToast.success(error?.message || 'RNPL updated error Encountered.');
              });
          }} />
      )
    });
  };

  const editReviewStage = (rnpl: any) => {
    RNPLApplication &&
      updateModalStates({
        show: true,
        size: 'md',
        children: (
          <EditReviewStage
            rnplApplicant={rnpl}
            onProceed={() => {
              closeModal();
              invalidateQueries();
            }}
            onClose={closeModal}
          />
        ),
        showCloseButton: false,
        classes: '!p-0 r-[5px]'
      });
  };

  const editRNPL = (section: string) => {
    RNPLApplication &&
      updateModalStates({
        show: true,
        size: 'md',
        children: (
          <EditRNPL
            rnplApplicant={RNPLApplication}
            onProceed={() => {
              closeModal();
              invalidateQueries();
            }}
            onClose={closeModal}
            section={section}
          />
        ),
        showCloseButton: false,
        classes: '!p-0 r-[5px]'
      });
  };

  const getActions = () => {
    const rnplActions = [
      {
        label: 'Generate payment schedules',
        callback: () => {
          generateRNPLPayment(String(rnplId), paymentDate)
            .then((response: any) => {
              showToast.success(response?.message || 'Payment Generated successfully.');
              invalidateQueriesPayments();
            })
            .catch((error: any) => {
              showToast.error(error?.message || 'Generate payment has failed.');
              console.log(error)
            });
        },
        icon: <CalendarClock className="h-4 w-4" />
      },
      {
        label: 'Apply loan',
        callback: () => rnplId && handleApplyLoanToRNPL(rnplId, invalidateQueries),
        icon: <AppWindow className="h-4 w-4" />
      },
    ];

    if (RNPLApplication) {
      RNPLApplication?.reviewStage == POLICY_REVIEW_STATES.IN_APPROVAL && user.isOwner() && rnplActions.push(
        // RNPLApplication?.reviewStage == POLICY_REVIEW_STATES.IN_APPROVAL && user.isSuperAdmin() && policyActions.push(
        {
          label: `Approve RNPL`,
          callback: () => {
            approveRNPL()
          },
          icon: <BadgeCheck className="h-4 w-4" />
        });

      RNPLApplication?.reviewStage !== POLICY_REVIEW_STATES.APPROVED && rnplActions.push(
        {
          label: `Edit`,
          callback: () => {
            editRNPL('')
          },
          icon: <Pencil className="h-4 w-4" />
        },
        {
          label: `Review RNPL Application`,
          callback: () => {
            editReviewStage(RNPLApplication)
          },
          icon: <FileSearch className="h-4 w-4" />
        },
      );
    }

    return rnplActions;
  };

  const getRowActions = (payment: any): ITableAction[] => {
    const actions = [];

    if (payment && payment?.paymentStatus !== PAYMENT_STATUS_STATES.SUCCESS) {
      actions.push(
        {
          label: 'Get payment link',
          callback: () => {
            if (payment) generatePaymentLink(payment.id);
          },
          icon: <Link2 className="h-4 w-4" />
        },
        {
          label: 'Send payment notification',
          callback: () => {
            if (payment) sendPaymentNotification(payment);
          },
          icon: <Send className="h-4 w-4" />
        },
        {
          label: 'Initiate direct charge',
          callback: () => {
            if (payment) {
              InitiateHubtelDirectCharge(payment);
            }
          },
          icon: <Zap className="h-4 w-4" />
        }
      );

      if (user.isOwner()) {
        // if (user.isReviewer()) {
        actions.push({
          label: 'Edit',
          callback: () => {
            if (payment) showEditPaymentModal(payment);
          },
          icon: <Pencil className="h-4 w-4" />
        });
      }

      if (payment?.paymentStatus == PAYMENT_STATUS_STATES.APPROVAL && user.isOwner())
        // if (payment?.paymentStatus == PAYMENT_STATUS_STATES.APPROVAL && user.isSuperAdmin())
        actions.push({
          label: 'Approve',
          callback: () => {
            if (payment) showPaymentApprovalModal(payment);
          },
          icon: <BadgeCheck className="h-4 w-4" />
        });
    }

    return actions;
  };

  const isOnCollateral = () => {
    switch (RNPLApplication?.vehicles?.natureOfInterest) {
      case 'Hire Purchaser':
        return 'YES';
      case 'Work & Pay driver':
        return 'YES';
      default:
        return 'NO';
    }
  };

  const isCarOwner = () => {
    switch (RNPLApplication?.vehicles?.natureOfInterest) {
      case NEW_OWNER_YET_TO_CHANGE_AT_DVLA:
        return 'YES';
      default:
        return 'NO';
    }
  };

  const rnplPreapproval = () => {
    RNPLApplication &&
      updateModalStates({
        show: true,
        size: 'md',
        children: (
          <RNPLPreapproval
            rnplApplicant={RNPLApplication}
            onProceed={() => {
              closeModal();
              invalidateQueries();
            }}
            onClose={closeModal}
          />
        ),
        showCloseButton: false,
        classes: '!p-0 r-[5px]'
      });
  };

  const otherInfo = () => {
    return (
      <div className="mt-5">
        <span className="font-semibold">Other Information</span>
        <div
          className={clsx(
            'grid border border-gray-300 p-2  rounded-2xl h-[230px] md:grid-cols-1 w-full '
          )}>
          <RNPLDetailsItem name={'Is vehicle on collateral?'} value={isOnCollateral()} />
          <RNPLDetailsItem name={'Are you the owner of the vehicle?'} value={isCarOwner()} />

          <RNPLDetailsItem
            name={'Does owner consent to RNPL?'}
            value={String(RNPLApplication?.ownerConsent === true ? 'YES' : 'NO') ?? '-'}
          />
          <RNPLDetailsItem>
            <TextArea
              name={'description'}
              label="Damage Description"
              value={RNPLApplication?.repairDescription}
              disabled={true}
              classes="italic"
            />
          </RNPLDetailsItem>
        </div>
      </div>
    );
  };

  const getProposer = (): JSX.Element => {
    return (
      <RNPLDetailsItemCard title={'Proposer'} icon={<UserPlus className='w-5 h-5 mr-2' />}>
        <>
          <div className="bg-gray-50 p-6 rounded-2xl h-full dark:bg-transparent dark:!text-darkBg-mainText dark:border dark:border-darkBg-border">
            <RNPLDetailsItem
              name='Name'
              value={capitalizeSentence(
                RNPLApplication?.customer?.firstName + ' ' + RNPLApplication?.customer?.lastName
              ) ?? '-'}
            />


            <RNPLDetailsItem
              name="Phone"
              value={
                <RedactInfo
                  infoType={REDACT_INFO_TYPES.PHONE}
                  info={getPhoneNumberFromShortCodeFormat(RNPLApplication?.customer?.phone) ?? '-'}
                  dataId={RNPLApplication?.ref ?? ''}
                  dataType="policy"
                  clickable={!user.isInsurer() && true}
                />
              } />

            <RNPLDetailsItem
              name="Other Phone"
              value={
                RNPLApplication?.customer?.otherPhone ? (
                  <RedactInfo
                    infoType={REDACT_INFO_TYPES.PHONE}
                    info={getPhoneNumberFromShortCodeFormat(RNPLApplication?.customer?.otherPhone) ?? '-'}
                    dataId={RNPLApplication?.ref ?? ''}
                    dataType="policy"
                    clickable={!user.isInsurer() && true}
                  />
                ) : (
                  RNPLApplication?.customer?.otherPhone ? getPhoneNumberFromShortCodeFormat(RNPLApplication?.customer?.otherPhone) : '-'
                )
              } />

            <RNPLDetailsItem name="Email" value={RNPLApplication?.customer.email ? RNPLApplication?.customer.email : '-'} />

            <RNPLDetailsItem name="Address">
              <ToolTip
                message={
                  <RedactInfo
                    info={RNPLApplication?.customer?.address ? RNPLApplication?.customer?.address : '-'}
                    totalToRedact={10}
                    dataId={RNPLApplication?.ref ?? ''}
                    dataType="policy"
                  />
                }
              >
                <div className="font-medium truncate w-full max-w-32">
                  {RNPLApplication?.customer?.address && RNPLApplication?.active ? (
                    <RedactInfo
                      info={RNPLApplication?.customer?.address ? RNPLApplication?.customer?.address : '-'}
                      totalToRedact={10}
                      dataId={RNPLApplication?.ref ?? ''}
                      dataType="policy"
                    />
                  ) : (
                    RNPLApplication?.customer?.address ? RNPLApplication?.customer?.address : '-'
                  )}
                </div>
              </ToolTip>
            </RNPLDetailsItem>

            <RNPLDetailsItem
              name="Date of Birth"
              value={
                RNPLApplication?.customer?.dateOfBirth ? (
                  <RedactInfo
                    info={getFormattedDate({ date: RNPLApplication?.customer.dateOfBirth })}
                    totalToRedact={6}
                    dataId={RNPLApplication?.ref ?? ''}
                    dataType="policy"
                    clickable={!user.isInsurer() && true}
                  />
                ) : (
                  '-'
                )
              }
            />

            <>
              <RNPLDetailsItem
                name="Do you have any other liabilities?"
                value={RNPLApplication?.customer?.liability ? 'Yes' : 'No'}
              />
              {RNPLApplication?.customer?.liability && (
                <>
                  <RNPLDetailsItem
                    name="How much are you owing?"
                    value={RNPLApplication?.customer?.liabilityDebt ?? ''}
                  />
                </>
              )}
            </>
          </div>

          <div className="bg-gray-50 p-4 rounded-2xl h-full dark:bg-transparent dark:!text-darkBg-mainText dark:border dark:border-darkBg-border">
            <RNPLDetailsItem
              name="ID Type"
              value={RNPLApplication?.customer?.idType ? capitalizeSentence(RNPLApplication?.customer?.idType) : ''}
            />

            {!user.isInsurer() && (
              <RNPLDetailsItem
                name="ID Expiry Date"
                value={getFormattedDate({ date: RNPLApplication?.customer?.idExpiry ?? '-' })}
              />
            )}



            <RNPLDetailsItem
              name="Occupation"
              value={RNPLApplication?.customer?.occupation ?? '-'}
            />

            <RNPLDetailsItem
              name="Employer Name"
              value={RNPLApplication?.customer?.employerName ?? '-'}
            />

            <RNPLDetailsItem
              name="Employer Address"
              value={RNPLApplication?.customer?.employerAddress ? RNPLApplication?.customer?.employerAddress : '-'}
            />
            <RNPLDetailsItem
              name="Employer Phone Number"
              value={
                getPhoneNumberFromShortCodeFormat(RNPLApplication?.customer?.employerPhone) ??
                '-'
              }
            />

            <RNPLDetailsItem
              name="Monthly Income Band"
              value={RNPLApplication?.customer?.monthlyIncomeBand ?? '-'}
            />


          </div>
        </>
      </RNPLDetailsItemCard>

    );
  };

  const getPaymentPlan = () => {
    return (
      <RNPLDetailsItemCard title='Quote Plan' classes='grid grid-cols-1' icon={<ClipboardList className='w-5 h-5 mr-2' />}>

        <div className='p-2 min-h-[330px]'>
          <RNPLDetailsItem
            classes='!flex-row justify-between items-center'
            name={'Created On'}
            value={RNPLApplication?.plan?.createOn ? moment(RNPLApplication?.plan?.createOn).format('DD-MMM-YYYY') : '-'}
          />

          <RNPLDetailsItem
            classes='!flex-row justify-between items-center'
            name={'Initial Deposit'}
            value={RNPLApplication?.plan?.initialDeposit ? RNPLApplication?.plan?.initialDeposit : '-'}
          />
          <RNPLDetailsItem
            classes='!flex-row justify-between items-center'
            name={'Frequency'}
            value={RNPLApplication?.plan?.frequency ? RNPLApplication?.plan?.frequency : '-'} />

          <RNPLDetailsItem
            classes='!flex-row justify-between items-center'
            name={'Installment Amount'}
            value={RNPLApplication?.plan?.installmentAmount ? RNPLApplication?.plan?.installmentAmount : '-'}
          />
          <RNPLDetailsItem classes='!flex-row justify-between items-center' name={'Total Amount'} value={RNPLApplication?.plan?.totalAmount ? RNPLApplication?.plan?.totalAmount : '-'} />
          <RNPLDetailsItem classes='!flex-row justify-between items-center' name={'Period'} value={RNPLApplication?.plan?.period ? RNPLApplication?.plan?.period : '-'} />
        </div>
      </RNPLDetailsItemCard>

    );
  };

  const getRNPLDetails = () => {
    return (

      <RNPLDetailsItemCard title='RNPL Details' classes='grid grid-cols-1' icon={<Info className='w-5 h-5 mr-2' />}>
        <div className="p-2 min-h-[330px]">

          <RNPLDetailsItem
            classes='!flex-row justify-between items-center'
            name={'Car Number'}
            value={RNPLApplication?.vehicles?.registrationNumber ?? '-'}
          />
          <RNPLDetailsItem
            classes='!flex-row justify-between items-center'
            name={"Owner's Phone"}
            value={
              getPhoneNumberFromShortCodeFormat(RNPLApplication?.vehicles?.ownerPhoneNumber) ?? '-'
            }
          />
          <RNPLDetailsItem
            classes='!flex-row justify-between items-center'
            name={'Repair Type'}
            value={RNPLApplication?.repairType ? capitalizeSentence(RNPLApplication?.repairType) : '-'}
          />
          <RNPLDetailsItem classes='!flex-row justify-between items-center' name={'Repair Cost'} value={RNPLApplication?.repairCost} />
          <RNPLDetailsItem
            classes='!flex-row justify-between items-center'
            name={'Nature of Interest'}
            value={RNPLApplication?.vehicles?.natureOfInterest ? RNPLApplication?.vehicles?.natureOfInterest : '-'}
          />
          <RNPLDetailsItem
            classes='!flex-row justify-between items-center'
            name={'Does owner consent to RNPL?'}
            value={String(RNPLApplication?.ownerConsent === true ? 'YES' : 'NO') ?? '-'}
          />
          <RNPLDetailsItem>
            <TextArea
              name={'description'}
              label="Damage Description"
              value={RNPLApplication?.repairDescription}
              disabled={true}
              classes="italic dark:!text-darkBg-mainText dark:bg-transparent dark:border dark:border-darkBg-border"
            />
          </RNPLDetailsItem>
        </div>

      </RNPLDetailsItemCard>
    );
  };

  const getAboutVehicleDetails = (): JSX.Element => {
    return (
      <div className="mt-5">
        <span className="font-semibold">Vehicle</span>
        <div
          className={clsx(
            'grid border border-gray-300 p-2  gap-5 rounded-2xl h-full md:grid-cols-2 w-full '
          )}>
          <div className="">
            <RNPLDetailsItem name="Vehicle Make" value={RNPLApplication?.vehicles?.maker ?? '-'} />
            <RNPLDetailsItem name="Vehicle Model" value={RNPLApplication?.vehicles?.model ?? '-'} />
            <RNPLDetailsItem
              name="Vehicle Type"
              value={RNPLApplication?.vehicles?.type.name ?? '-'}
            />
            <RNPLDetailsItem
              name="Vehicle Color"
              value={
                RNPLApplication?.vehicles?.color
                  ? sentenceCase(RNPLApplication?.vehicles?.color)
                  : '-'
              }
            />
            <RNPLDetailsItem
              name="Chassis / VIN Number"
              value={RNPLApplication?.vehicles?.chassisNumber ?? '-'}></RNPLDetailsItem>
            <RNPLDetailsItem name="CC" value={RNPLApplication?.vehicles?.cc ?? '-'} />
            <RNPLDetailsItem
              name="Manufactured Year"
              value={RNPLApplication?.vehicles?.manufacturedYear ?? '-'}
            />
            <RNPLDetailsItem
              name="Registration Year"
              value={RNPLApplication?.vehicles?.registrationYear ?? '-'}
            />
            <RNPLDetailsItem
              name="Vehicle Usage"
              value={RNPLApplication?.vehicles?.vehicleUsage ? capitalizeSentence(RNPLApplication?.vehicles?.vehicleUsage) : '-'}
            />
          </div>

          <div className="">
            <RNPLDetailsItem
              name="Number of Passengers"
              value={RNPLApplication?.vehicles?.maxSeat ?? '-'}
            />
            <RNPLDetailsItem
              name="Vehicle Owner"
              value={RNPLApplication?.vehicles?.ownerName ?? '-'}
            />
            <RNPLDetailsItem
              name="Vehicle Owner's Phone"
              value={
                RNPLApplication?.vehicles?.ownerPhoneNumber
                  ? getPhoneNumberFromShortCodeFormat(RNPLApplication?.vehicles?.ownerPhoneNumber)
                  : '-'
              }
            />
            <RNPLDetailsItem
              name="Vehicle Main Driver"
              value={RNPLApplication?.vehicles?.driverName ?? '-'}
            />

            <RNPLDetailsItem
              name="Vehicle Insured Value"
              value={
                numberWithCommas(
                  String(
                    RNPLApplication?.vehicles?.issuedValue ??
                    RNPLApplication?.Vehicles?.issuedValue.toFixed(2)
                  )
                ) ?? '-'
              }
            />

            <RNPLDetailsItem
              name="Nature of Interest"
              value={
                RNPLApplication?.vehicles?.natureOfInterest
                  ? capitalizeSentence(RNPLApplication?.vehicles?.natureOfInterest)
                  : '-'
              }
            />

            <RNPLDetailsItem
              name="Accessories Installed"
              value={RNPLApplication?.vehicles?.installedAccessoriesDetails ?? '-'}
            />

            <RNPLDetailsItem
              name="Accessories Installed Value"
              value={RNPLApplication?.vehicles?.installedAccessoriesValue ?? '-'}
            />

            <RNPLDetailsItem
              name="Vehicle Registration Number"
              value={RNPLApplication?.vehicles?.registrationNumber ?? '-'}
            />
          </div>
        </div>
      </div>
    );
  };

  const columns = React.useMemo(
    () => [
      {
        id: 'selection',
        Header: ({ getToggleAllRowsSelectedProps }: any) => (
          <div className="">
            <input type="checkbox" {...getToggleAllRowsSelectedProps()} />
          </div>
        ),
        Cell: ({ row }: any) => (
          <div className="">
            <input type="checkbox" {...row.getToggleRowSelectedProps()} />
          </div>
        )
      },
      {
        Header: 'M',
        columns: [
          {
            Header: 'ID',
            accessor: 'id',
            Cell: (row: any) => {
              return <span>{row.cell.value ?? '-'}</span>;
            }
          },
          {
            Header: 'Due Date',
            accessor: 'dueDate',
            Cell: (row: any) => {
              return (
                <span>{row.cell.value ? getFormattedDate({ date: row.cell.value }) : '-'}</span>
              );
            }
          },
          {
            Header: 'Paid Date',
            accessor: 'dateOfPayment',
            Cell: (row: any) => {
              return (
                <span>{row.cell.value ? getFormattedDate({ date: row.cell.value }) : '-'}</span>
              );
            }
          },
          {
            Header: 'Application Number',
            accessor: 'applicationNumber',
            Cell: (row: any) => {
              return <span className="">{row.cell.value ?? '-'}</span>;
            }
          },
          {
            Header: 'Channel',
            accessor: 'channel',
            Cell: (row: any) => {
              return (
                <span className="">{getFormattedPaymentChannel(row.cell.value) ?? '-'}</span>
              );
            }
          },
          {
            Header: 'Processor',
            accessor: 'processor',
            Cell: (row: any) => {
              return <span className="">{row.cell.value ?? '-'}</span>;
            }
          },
          {
            Header: 'Amount',
            accessor: 'preAmount',
            Cell: (row: any) => {
              return <span className="">{row.cell.value ?? '-'}</span>;
            }
          },
          {
            Header: 'Charged Amount',
            accessor: 'amount',
            Cell: (row: any) => {
              return <span className="">{row.cell.value ?? '-'}</span>;
            }
          },
          {
            Header: 'Processor Ref',
            accessor: 'reference',
            Cell: (row: any) => {
              return <span className="">{row.cell.value ?? '-'}</span>;
            }
          },

          {
            Header: 'Status',
            accessor: 'paymentStatus',
            Cell: (row: any) => {
              return <PaymentStatus row={row} actions={getRowActions(row.row.original)} />;
            }
          }

        ]
      }
    ],
    []
  );
  
  const getPaymentActions = () => {
    let actions = [
      {
        label: 'Activate preapproval',
        callback: () => rnplPreapproval(),
        icon: <ShieldCheck className="h-4 w-4" />

      },
      {
        label: 'Regenerate payment schedules',
        callback: () => console.log('Regenerate payment schedules'),
        icon: <RotateCcw className="h-4 w-4" />
      },
      {
        label: 'Apply discount',

        callback: () => console.log('Apply discount'),
        icon: <Percent className="h-4 w-4" />
      }
    ];

    if (RNPLApplication) {
      if (!payments || payments.length === 0) {
        actions.push({
          label: 'Generate payment schedules',
          callback: () => console.log('Generate payment schedules'),
          icon: <CalendarClock className="h-4 w-4" />
        });
      }

    }

    return actions;
  };

  const paymentTable = () => {
    return (
      <>


        <div className="bg-white rounded-2xl mt-6 px-4 dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border" ref={pageRef} >
          <TabNavItem
            id="payments"
            title="Payments"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            count={payments && payments?.length}
          />

          <>
            <div className="flex flex-col md:flex-row md:justify-between md:items-center">
              <div className='flex'>
                <span><Wallet className='w-5 h-5 mr-3' /></span>
                <span className="font-bold text-[15px]">Total Premium: </span>
                <span className="px-2">
                  {RNPLApplication?.plan?.totalAmount ? RNPLApplication?.plan?.totalAmount.toFixed(2) : '-'}
                </span>
              </div>
              <div className='flex'>
                <CheckCircle className='w-5 h-5 mr-3' />
                <span className="font-bold text-[15px]">Total Paid:</span>{' '}
                <span className="px-2">  {totalPaymentsAmount() ? totalPaymentsAmount().toFixed(2) : 0}</span>
              </div>
              <div className='flex'>
                <CreditCard className='w-5 h-5 mr-3' />
                <span className="font-bold text-[15px]">Balance Remaining:</span>{' '}
                <span className="px-2">{payments ? (RNPLApplication?.plan?.totalAmount - totalPaymentsAmount()).toFixed(2) : 0}</span>
              </div>
              <div className="flex ">
                <Percent className='w-5 h-5 mr-3' />
                <span className="font-bold text-[15px]">Discount Applied:</span>{' '}
                <div className="flex justify-center items-center">
                  <div className="px-2">-</div>

                </div>
              </div>
              <div className="flex items-center justify-end md:flex-none">
                {getPaymentActions()?.length > 0 && (
                  <ActionsPopOnMe actions={getPaymentActions()} popOptionClasses="!min-w-[150px] ">
                    <div className="cursor-pointer py-1 px-2  border border-primary-main rounded-full w-fit">
                      Payment Actions
                    </div>
                  </ActionsPopOnMe>
                )}
              </div>
            </div>
            {loadingPayment ? <div className='p-5'><Loader message='Fetching payments. Please wait...' brollyLoader /></div> : <TabContent id={'payments'} activeTab={activeTab}>
              <div className="w-full md:overflow-y-auto max-h-[400px] relative">
                <GTable
                  showCheckboxes
                  selectionChanged={(selectedObjects: any[], selectedIndexes: number[]) => {
                    const paymentIdList = selectedObjects.map((payment) => payment.id);

                  }}
                  isRowLinked={false}
                  stickyHeader
                  columns={columns}
                  data={orderPaymentsById}
                  tableType="payment"
                  showSearch={false}
                  loading={loadingPayment}
                  tableContainerId="tableId"
                  classes='max-h-[300px]'
                />
              </div>
            </TabContent>}
          </>
        </div>
      </>
    );
  };

  const getRNPLApplication = () => {
    return (
      <div className="bg-white rounded-2xl shadow overflow-hidden dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border">
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 dark:bg-darkBg dark:border-darkBg-border">
          <h2 className="text-lg font-medium text-gray-900 flex items-center dark:text-darkBg-mainText">
            <BsShield className="h-5 w-5 mr-2 text-gray-500 dark:text-darkBg-mainText" />
            Premium Overview
          </h2>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-1 gap-6">
            <div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <p className="text-sm font-medium text-gray-500">Application Number</p>
                  <p className="mt-1 text-sm text-gray-900 dark:text-darkBg-mainText">{RNPLApplication?.applicationNumber ?? '-'}</p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Insurer Name</p>
                  <p className="mt-1 text-sm text-gray-900 dark:text-darkBg-mainText">{RNPLApplication?.insurer?.name ?? '-'}</p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Initiated By</p>
                  <p className="mt-1 text-sm text-gray-900 dark:text-darkBg-mainText">{RNPLApplication?.staff?.fullName ?? '-'}</p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Initiated On</p>
                  <p className="mt-1 text-sm text-gray-900 dark:text-darkBg-mainText">{RNPLApplication?.createdOn ? getFormattedDate({ date: RNPLApplication?.createdOn , showTime: true }) : '-'}</p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Verified On</p>
                  <p className="mt-1 text-sm text-gray-900 dark:text-darkBg-mainText">{RNPLApplication?.verifiedOn ? getFormattedDate({ date: RNPLApplication?.verifiedOn , showTime: true }) : '-'}</p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Last Updated</p>
                  <p className="mt-1 text-sm text-gray-900 dark:text-darkBg-mainText">{RNPLApplication?.updatedOn ? getFormattedDate({ date: RNPLApplication?.updatedOn , showTime: true }) : '-'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    )
  }

  const getKycStatusInfo = (status: string | boolean) => {
    switch (status) {
      case 'verified':
      case true:
        return {
          color: 'bg-green-100 text-green-800',
          icon: <AiOutlineCheckCircle className="h-4 w-4 text-green-500" />
        };
      case 'pending':
      case false:
        return {
          color: 'bg-gray-100 text-gray-800',
          icon: <AiOutlineClockCircle className="h-4 w-4  text-gray-500" />
        };
      case 'rejected':
        return {
          color: 'bg-red-100 text-red-800',
          icon: <AiOutlineCloseCircle className="h-4 w-4 text-red-500" />
        };
      case 'expired':
        return {
          color: 'bg-orange-100 text-orange-800',
          icon: <AiOutlineExclamationCircle className="h-4 w-4 text-orange-500" />
        };
      default:
        return {
          color: 'bg-gray-100 text-gray-800',
          icon: <AiOutlineQuestionCircle className="h-4 w-4 text-gray-500" />
        };
    }
  };

  const getRiskScoreInfo = (score: number) => {
    if (score <= 30) {
      return {
        color: 'bg-green-100 text-green-800',
        icon: <MdTrendingUp className="h-4 w-4 text-green-500" />
      };
    } else if (score <= 70) {
      return {
        color: 'bg-yellow-100 text-yellow-800',
        icon: <AiOutlineExclamationCircle className="h-4 w-4 text-yellow-500" />
      };
    } else {
      return {
        color: 'bg-red-100 text-red-800',
        icon: <MdTrendingDown className="h-4 w-4 text-red-500" />
      };
    }
  };

  const getCustomerInfo = () => {
    return (
      <div className="bg-white rounded-2xl shadow overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
          <h2 className="text-lg font-medium text-gray-900 flex items-center">
            <UserIcon className="h-5 w-5 mr-2 text-gray-500" />
            Customer Information
          </h2>
        </div>
        <div className="p-6">
          <div className="flex items-center mb-4">
            <div className="flex-shrink-0 h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center">
              <UserIcon className="h-6 w-6 text-gray-500" />
            </div>
            <div className="ml-4">
              <h3 className="text-lg whitespace-nowrap font-medium text-gray-900">{RNPLApplication?.customer?.firstName && RNPLApplication?.customer?.lastName ? (RNPLApplication?.customer?.firstName + ' ' + RNPLApplication?.customer?.lastName) : "-"}</h3>
              <Link to={`${getDashboardBase()}/customers/${RNPLApplication?.customer?.id}`} className="text-sm whitespace-nowrap text-blue-600 hover:underline">
                View Customer Profile
              </Link>
            </div>
            <div className="flex flex-col items-start gap-2 mb-1">

              {/* KYC Status Badge */}
              <div className={`flex items-center w-fit px-2 py-0.5 rounded-full text-xs ${getKycStatusInfo(RNPLApplication?.customer?.idVerified).color} md:ml-2`}>
                {getKycStatusInfo(RNPLApplication?.customer?.idVerified).icon}
                <span className="ml-1 font-medium capitalize whitespace-nowrap">KYC: {RNPLApplication?.customer?.idVerified ? 'Verified' : 'Not Verified'}</span>
              </div>


              {/* Risk Score Badge */}
              {
                (
                  <div className={`flex items-center px-2 py-0.5 rounded-full text-xs ${RNPLApplication?.customer?.kycAnalysis?.score ? getRiskScoreInfo(RNPLApplication?.customer?.kycAnalysis?.score).color : ''} ml-2`}>
                    {getRiskScoreInfo(RNPLApplication?.customer?.kycAnalysis?.score).icon}
                    {/* <span className="ml-1 font-medium">Risk: {RNPLApplication?.vehicle?.score}</span> */}
                    <span className="ml-1 font-medium">Risk: {RNPLApplication?.customer?.kycAnalysis?.risk ? RNPLApplication?.customer?.kycAnalysis?.risk : '-'}</span>
                  </div>
                )
              }
            </div>
          </div>
          <div className="mt-5 grid grid-cols-1 gap-4">
            <div className="flex items-center">
              <BsMailbox className="h-5 w-5 text-gray-400 mr-2" />
              <span className="text-sm text-gray-900">{RNPLApplication?.customer?.email ? RNPLApplication?.customer?.email : '-'}</span>
            </div>
            <div className="flex items-center">
              <PhoneIcon className="h-5 w-5 text-gray-400 mr-2" />
              <span className="text-sm text-gray-900">{RNPLApplication?.customer?.phone ? getPhoneNumberFromShortCodeFormat(RNPLApplication?.customer?.phone) : '-'}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const getFinancedPartner = () => {
    return (

      <RNPLDetailsItemCard title='Financed Partner' classes='grid grid-cols-1'>


        <div className="p-2 h-[260px]">

          <RNPLDetailsItem
            classes='!flex-row justify-between items-center'
            name={'Partner Logo'}
            value={<img src={RNPLApplication?.insurer?.logo} width='65px' className='rounded-full' alt="partner logo" />}
          />
          <RNPLDetailsItem
            classes='!flex-row justify-between items-center'
            name={'Partner Name'}
            value={RNPLApplication?.insurer?.name}
          />
          <RNPLDetailsItem
            classes='!flex-row justify-between items-center'
            name={'Partner Email'}
            value={RNPLApplication?.insurer?.email}
          />
          <RNPLDetailsItem
            classes='!flex-row justify-between items-center'
            name={'Partner Contact'}
            value={getPhoneNumberFromShortCodeFormat(RNPLApplication?.insurer?.phoneNumber)}
          />
          <RNPLDetailsItem
            classes='!flex-row justify-between items-center'
            name={'Country'}
            value={RNPLApplication?.insurer?.country?.name}
          />
        </div>


      </RNPLDetailsItemCard>

    )
  }

  const getDocumentUpload = () => {
    return (
      <RNPLDetailsItemCard title='Document(s)' classes='grid grid-cols-1'>


        <div className="p-2 rounded-2xl md:max-h-[125px] overflow-y-scroll">
          <ul className="divide-y divide-gray-200">
            {documents.map((document) => (
              <li key={document.id} className="py-3 flex justify-between items-center">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <FileText className="h-5 w-5 text-gray-400" />
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium text-gray-900">{document.name}</p>
                    {/* <p className="text-xs text-gray-500">{document.uploadedAt} • {formatFileSize(document.size)}</p> */}
                  </div>
                </div>
                <div className="flex space-x-2">
                  <button className="text-gray-400 hover:text-gray-500">
                    <Eye className="h-4 w-4" />
                  </button>
                  <button className="text-gray-400 hover:text-gray-500">
                    <Download className="h-4 w-4" />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>

      </RNPLDetailsItemCard>

    )
  }

  const scrollToPaymentHistory = () => {
    if (pageRef.current) {
      pageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  if (!loading && error) {
    return (
      <div className='text-gray-500 text-2xl h-screen flex items-center justify-center'>
        <span className='text-red-400'>Oups! </span>{" "}
        An error occurred. Kindly retry later.
      </div>
    )
  }

  return (
    <>
      <Page title={`RNPL ${rnplId}`} className="">
        {loading ? (
          <div className="h-screen flex items-center justify-center">
            <Loader message="Loading page. Please wait..." brollyLoaderFixed  />
          </div>
        ) : (
          !error && <div className=" h-fit p-5" >
            <div className="flex px-3 md:px-0 flex-col md:flex-row  justify-between">
              <div className="flex items-center justify-start gap-5">
                <div className="w-fit">
                  <BackButton
                    onClick={() => navigate(`${getDashboardBase()}/premium-RNPL`, { replace: true })}
                  />
                </div>

                <div className="w-full min-w-fit text-2xl font-semibold dark:text-darkBg-mainText">Application-{rnplId ?? '-'} </div>

                <PolicyStatus
                  status={RNPLApplication?.reviewStage ? capitalizeSentence(RNPLApplication?.reviewStage) : '-'}
                  classes="rounded-full px-2  !w-fit"
                />

              </div>

              <div className="flex flex-col min-[400px]:flex-row space-x-2 items-center mt-6 md:mt-0 justify-between">
                <div className=" flex items-center justify-center gap-x-3 mb-2 min-[400px]:mb-0">
                  {' '}
                  {getActions().length > 0 && (
                    <PopOnMe actions={getActions()}>
                      <div className="cursor-pointer py-1 px-2  border border-primary-main rounded-full dark:text-darkBg-mainText">
                        Actions
                      </div>
                    </PopOnMe>
                  )}
                </div>
              </div>
            </div>
            <div className="px-3 md:px-0 mt-6">

              <div className="flex flex-col gap-8 min-[1200px]:flex-row">
                <div className="flex flex-col min-[1200px]:w-3/5">
                  <div>{getRNPLApplication()}</div>
                  <div className="">{getProposer()}</div>
                  {/* <div className="md:w-full"> {getPremiumRNPLDetails()}</div> */}
                  <div className="mt-5 "> <VehicleInfo vehicle={RNPLApplication?.vehicles} /></div>
                  <div className="grid grid-cols-1  lg:grid-cols-2 gap-4">
                    {/* <div className="md:w-full">{getFinancedPartner()}</div> */}
                    <div className="md:w-full">{getRNPLDetails()}</div>
                    <div className="md:w-full"> {getPaymentPlan()}</div>
                  </div>

                </div>

                {/* Activity Section */}

                <div className="md:col-span-1 w-full  min-[1200px]:w-2/5 ">
                  <CustomerInfo
                    firstName={RNPLApplication?.customer?.firstName}
                    lastName={RNPLApplication?.customer?.lastName}
                    businessName={RNPLApplication?.customer?.businessName}
                    email={RNPLApplication?.customer?.email}
                    phoneNumber={RNPLApplication?.customer?.phone}
                    otherPhone={RNPLApplication?.customer?.otherPhone}
                    id={RNPLApplication?.customer?.id}
                    idNumber={RNPLApplication?.customer?.idNumber}
                    idVerified={RNPLApplication?.customer?.idVerified}
                    emailVerified={RNPLApplication?.customer?.emailVerified}
                    phoneVerified={RNPLApplication?.customer?.phoneVerified}
                    score={RNPLApplication?.customer?.kycAnalysis?.score}
                    risk={RNPLApplication?.customer?.kycAnalysis?.risk}
                    type={RNPLApplication?.customer?.customerType}
                    isClickable={true}
                    query='displayRNPLApplicant'
                  />

                  <RNPLDetailsItemCard title='RNPL Timeline' classes='grid md:grid-cols-1 max-h-[412px] overflow-y-scroll' icon={<LuCalendarClock className="h-5 w-5 mr-2 text-gray-500" />}>
                    <div>
                      <ActivityStepper
                        activityStreams={RNPLApplication?.activityStreams}
                        orientation="vertical"
                        currentStep={0}
                      />
                    </div>
                  </RNPLDetailsItemCard>

                  <div className='mt-5'><PaymentAnalysis paymentAnalysis={RNPLApplication?.customer} handleViewFullPayment={scrollToPaymentHistory} handleRunPaymentAnalysis={() => { }} /></div>
                  {/* <div>{getDocumentUpload()}</div>  */}
                </div>

              </div>
            </div>

            {paymentTable()}
          </div>
        )}

        <ModalComponent />
      </Page>
    </>
  );
};

export default RNPLApplicantDetails;



type RNPLDetailsItemProps = {
  name?: string;
  value?: string | number | JSX.Element;
  children?: React.ReactNode;
  classes?: string;
};

interface IRNPLDetailsItemCard {
  title: string;
  classes?: string;
  children: JSX.Element;
  icon?: React.ReactElement;
}
const RNPLDetailsItem = ({ name, value, children, classes }: RNPLDetailsItemProps) => {
  return (
    <div className={clsx(`flex flex-col py-1 `, classes)}>
      <div className="text-gray-600 ">{name && `${name}:`}</div>
      <div className="flex items-center gap-1">
        <span className="truncate text-[14px] font-medium whitespace-nowrap">{value}</span>
      </div>
      {children}
    </div>
  );
};

const RNPLDetailsItemCard = ({ title, classes, children, icon }: IRNPLDetailsItemCard): JSX.Element => {
  return (

    <div className="mt-5 bg-white rounded-2xl shadow-md overflow-hidden dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border">
      <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 dark:bg-darkBg dark:border-darkBg-border">
        <h2 className="text-lg font-medium text-gray-900 flex items-center dark:text-darkBg-mainText">
          {icon}
          {title}
        </h2>
      </div>
      <div
        className={clsx(
          'grid py-6  px-4 rounded-2xl h-full grid-cols-1 gap-5 ', classes ? classes : 'md:grid-cols-2 '
        )}>
        {children}
      </div>
    </div>
  );
};


const getDocumentPlaceholder = (type: POLICY_DOCUMENT_TYPES | undefined): JSX.Element => {
  switch (type) {
    case POLICY_DOCUMENT_TYPES.ROADWORTHY:
      return (
        <div className="w-full max-h-20 border-[2px] border-opacity-30 border-black p-3 flex justify-center items-center"></div>
      );

    default:
      return (
        <div className="w-full max-h-20 border-[2px] border-opacity-30 border-black p-3 flex justify-center items-center"></div>
      );
  }
};

const previewDocument = (document: IPolicyDocument) => {
  window.open(document.docUrl, '_blank');
};

const downloadDocument = (document: IPolicyDocument) => {
  downloadPolicyDocument(document.id)
    .then((response: any) => {
      if (response) {
        fileDownload(response.data, `Brolly Africa - ${document.docType}.pdf`);
      }
    })
    .catch(() => {
      showToast.error('Failed to download document. Please try again later');
    });
};


function generatePaymentLink(id: any) {
  console.log('generatePaymentLink')
}

function sendPaymentNotification(payment: any) {
  console.log('sendPaymentNotification')
}

function InitiateHubtelDirectCharge(payment: any) {
  console.log('InitiateHubtelDirectCharge')
}

function showEditPaymentModal(payment: any) {
  console.log('showEditPaymentModal')
}

function showPaymentApprovalModal(payment: any) {
  console.log('showPaymentApprovalModal')
}


const showHubtelPreapprovalModal = (RNPL: any) => {

  if (RNPL) {

  }
};

function updateModalStates(arg0: { show: boolean; children: import("react/jsx-runtime").JSX.Element; size: string; }) {
  throw new Error('Function not implemented.');
}

